import { styled, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { colors, typography } from '@resiliatech/birdsong'
import { explanationCopy } from './StoryAiCopy'

const renderContexts = (activeContext: string) =>
  Object.keys(explanationCopy).map((key) => {
    const cont = explanationCopy[key]
    return (
      <CopyContainer
        key={key}
        active={key === activeContext}
        data-active={key === activeContext}
        id={`expl-${key}`}
      >
        <Typography variant={cont.header.variant}>
          {cont.header.copy}
        </Typography>
        {cont?.body?.copy}
      </CopyContainer>
    )
  })

type Props = {
  focusedInput: string
}

export const StoryAiExplanation = ({ focusedInput }: Props) => {
  const [activeElementHeight, setActiveElementHeight] = useState<number>(0)

  useEffect(() => {
    const activeElement = document.querySelector('[data-active="true"]')
    if (activeElement) {
      setActiveElementHeight(activeElement.clientHeight)
    }
  }, [focusedInput])

  return (
    <Container height={activeElementHeight}>
      {renderContexts(focusedInput)}
    </Container>
  )
}

const Container = styled('div')<{ height: number }>`
  display: flex;
  width: 282px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  background: ${colors.content.aiLight};
  position: relative;
  height: ${({ height }) => height}px;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
`

const CopyContainer = styled('div')<{ active?: boolean }>`
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: all 0.5s ease-in-out;
  position: absolute;
  padding: 20px;
  pointer-events: ${({ active }) => (active ? 'all' : 'none')};
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    margin: 0;
    &.example {
      text-transform: uppercase;
      ${typography.down2.regularSans.styles}
      font-size: 12px;
      line-height: 250%; /* 30px */
      letter-spacing: 1px;
    }
  }

  h3,
  h4 {
    font-family: 'Source Sans Pro';
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-weight: 600;
  }
  h3 {
    font-size: 20px;
    line-height: 135%; /* 27px */
  }
  h4 {
    font-size: 16px;
    line-height: 120%; /* 19.2px */
  }
`
